import { EntityType } from 'common/enums';
import { EntityVM } from 'common/models/data/entity.model';
import { ExportRequestDto } from '../models/export.model';
import { ExtractType } from 'common/enums/data.enum';
import { UseMasterDataAccess } from '../role-access-hooks/useMasterDataAccess';

export const createExportRequestPayload = (data: EntityVM): ExportRequestDto => {
    switch (data.entityType) {
        case EntityType.Category:
            return {
                categoryId: data.id,
                extractType: ExtractType.Category
            };
            break;
        case EntityType.SubCategory:
            return {
                categoryId: data.catId,
                subCategoryId: data.id,
                extractType: ExtractType.SubCategory
            };
            break;
        case EntityType.Indicator:
            return {
                categoryId: data.catId,
                subCategoryId: data.hierarchyId,
                indicatorId: data.id,
                extractType: ExtractType.Indicator
            };
            break;
        default:
            return {
                extractType: ExtractType.FullData
            };
    }
};

export const getisEditActionAccess = (
    entityType: string,
    masterDataFeatureActionList: UseMasterDataAccess
): boolean => {
    switch (entityType) {
        case EntityType.Category:
            return masterDataFeatureActionList.categoryFeatureAccess.isEditDisabled;
        case EntityType.SubCategory:
            return masterDataFeatureActionList.subCategoryFeatureAccess.isEditDisabled;
        case EntityType.Indicator:
            return masterDataFeatureActionList.indicatorFeatureAccess.isEditDisabled;
        default:
            return false;
    }
};

export const getIsApplyDiscardAccess = (
    masterDataFeatureActionList: UseMasterDataAccess
): boolean => {
    const isAccessDisabled =
        Object.values(masterDataFeatureActionList.categoryFeatureAccess).some(
            (value) => value === false
        ) ||
        Object.values(masterDataFeatureActionList.subCategoryFeatureAccess).some(
            (value) => value === false
        ) ||
        Object.values(masterDataFeatureActionList.indicatorFeatureAccess).some(
            (value) => value === false
        );

    return !isAccessDisabled;
};
